import { capitalize } from 'inflection'
import type * as Style from '../../index.js'
import { Boolean, Keyword, Number } from '../../values/index.js'

export enum WordBreak {
  'normal' = 'normal',
  'break-word' = 'break-word',
  'break-all' = 'break-all',
  'hyphens' = 'hyphens'
}

export enum TextAlign {
  'left' = 'left',
  'center' = 'center',
  'right' = 'right',
  'justify' = 'justify'
}

export const Props = (props: any = {}) => ({
  textAlign: Keyword<TextAlign>(props.textAlign, TextAlign),
  lines: Number(props.lines),
  ellipsis: Boolean(props.ellipsis) ?? Number(props.lines) === 1,
  wordBreak: Keyword<WordBreak>(props.wordBreak, WordBreak, WordBreak['normal'])
})
export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const label = 'Text settings'
export const type = 'lines'
export const property = 'linesIds'
export const category = 'aspect'
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => {
  const rulesToDisplay = []
  if (props.textAlign !== 'left') rulesToDisplay.push(capitalize(props.textAlign))
  if (props.lines === 1) rulesToDisplay.push(props.ellipsis ? 'Ellipsis' : 'Display')
  if (props.lines > 1) rulesToDisplay.push(`max ${props.lines} lines`)
  return rulesToDisplay.join(' / ')
}
